__webpack_require__.p = "https://static.codingame.com/start/";